import * as React from "react";
const SvgFiRrTransporter1 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-transporter-1_svg__a)">
      <path
        fill="#062147"
        d="M9.5 2.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M4.159 13.459l3.319-5.163A4.98 4.98 0 0 1 11.683 6h.633a4.98 4.98 0 0 1 4.206 2.296l3.318 5.163a1 1 0 1 1-1.682 1.082l-3.159-4.914V13a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V9.628L5.84 14.541a1 1 0 1 1-1.681-1.082M11.683 8q-.35 0-.684.078V12h2V8.078A3 3 0 0 0 12.315 8zm7.316 14H5a1 1 0 1 0 0 2h14a1 1 0 1 0-.001-2m-10-5a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zM4.47 6.243l.357-1.43 1.432-.385a1 1 0 0 0-.035-1.94L4.82 2.163 4.469.757a1 1 0 0 0-1.94 0l-.354 1.418-1.418.354a1.001 1.001 0 0 0 0 1.941l1.418.354.354 1.418a1 1 0 0 0 1.94 0zm19.045-1.978-1.299-.492-.52-1.301a.75.75 0 0 0-1.394 0l-.523 1.308-1.308.523a.75.75 0 0 0 0 1.394l1.308.523.523 1.308a.75.75 0 0 0 1.394 0l.526-1.316 1.318-.556a.75.75 0 0 0-.025-1.391"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-transporter-1_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTransporter1;
